import * as React from 'react';

import { cn } from '@/lib/utils';

/**
 * EmptyState — the canonical "no data" affordance. Replaces ad-hoc
 * "No X found" markup so every empty view is consistent (Fluent tokens only).
 * All copy is passed in by the caller (keep i18n at the call site).
 */
function EmptyState({
    icon,
    title,
    description,
    action,
    className,
    ...props
}: React.ComponentProps<'div'> & {
    icon?: React.ReactNode;
    title: React.ReactNode;
    description?: React.ReactNode;
    action?: React.ReactNode;
}) {
    return (
        <div
            data-slot="empty-state"
            className={cn(
                'flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed bg-card px-6 py-12 text-center',
                className,
            )}
            {...props}
        >
            {icon ? (
                <div className="flex size-12 items-center justify-center rounded-lg bg-accent text-accent-foreground [&>svg]:size-6">
                    {icon}
                </div>
            ) : null}
            <div className="space-y-1">
                <h3 className="text-base font-semibold">{title}</h3>
                {description ? (
                    <p className="mx-auto max-w-sm text-sm text-muted-foreground">{description}</p>
                ) : null}
            </div>
            {action ? <div className="mt-1">{action}</div> : null}
        </div>
    );
}

export { EmptyState };
